import { render, staticRenderFns } from "./LawNormCreate.vue?vue&type=template&id=48a54050"
import script from "./LawNormCreate.vue?vue&type=script&lang=js"
export * from "./LawNormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports